import { useRef, type ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { useFocusTrap } from '../lib/use-focus-trap.js'

interface ModalProps {
  titleId: string
  onClose: () => void
  children: ReactNode
}

/**
 * Diálogo centrado sobre el tablero. Cuenta como "menú flotante" de
 * CLAUDE.md §6: puede llevar sombra suave, radio de 8px.
 */
export function Modal({ titleId, onClose, children }: ModalProps) {
  const dialogRef = useRef<HTMLDivElement>(null)
  useFocusTrap(dialogRef, onClose)

  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      onClick={onClose}
    >
      <div
        ref={dialogRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
        onClick={(event) => event.stopPropagation()}
        className="w-full max-w-sm rounded-panel bg-surface p-6 shadow-lg outline-none"
      >
        {children}
      </div>
    </div>,
    document.body,
  )
}
